import { NoData1 } from "@zenith/assets/illustrations/NoData1";
import { EmptyState } from "@zenith/components/ui/EmptyStateComponent/empty-state-component/empty-state-component";
import { memo } from "react";

const EmptyChartCardComponent = memo(function EmptyChartCardComponent() {
  return (
    <div className="flex h-96 w-96 grow flex-col items-center justify-center gap-2">
      <EmptyState
        title=" No Data Available"
        description="There is currently no data to display."
        illustration={
          <div className="flex w-full justify-center">
            <NoData1 className="block h-20 w-100 text-primary-300" />
          </div>
        }
      />
    </div>
  );
});

export default EmptyChartCardComponent;
